module.exports = __webpack_public_path__ + "media/images/country_flags/ec-1949666c64ce336557bac5d03846f37c.png";